module.exports = "https://r.zoocdn.com/_next/static/images/landing-pages-popular-9b8eaa1d8ce9028ac445148cc8400c98.svg";